<template>
  <div class="empty-product">
    <svg-icon icon-class="TC_empty_product"></svg-icon>
    <div class="empty-title">
        <p class="title-bold">产品已下线！</p>
        <p>该产品已下线，请选择其他产品</p>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.empty-product{
    width: 375px;
    height: 100vh;
    text-align: center;
    background: #fff;
    .svg-icon{
        width: 211px;
        height: 215px;
        margin-top: 139px;
    }
    .empty-title{
        margin-top: 37px;
        font-family: PingFang SC;
        font-weight: Medium;
        font-size: 10px;
        color: #999999;
        .title-bold{
            padding-bottom: 5px;
            font-size: 15px;
            font-weight: bold;
            color: #333333;
        }
    }
}

</style>